
import { createTheme } from "@mui/material/styles";
import { red } from '@mui/material/colors';
// https://mui.com/material-ui/customization/color/

const temaClaro = createTheme({
    typography: {
        fontFamily: '"Be Vietnam Pro", sans-serif',
        h1: { fontFamily: '"Vollkorn", serif' },
        h2: { fontFamily: '"Vollkorn", serif' },
        h3: { fontFamily: '"Vollkorn", serif' },
        h4: { fontFamily: '"Vollkorn", serif' },
        h5: { fontFamily: '"Vollkorn", serif' },
        h6: { fontFamily: '"Vollkorn", serif' },
    },
    palette: {
        mode: 'light',
        primary: {
            main: '#FDB813', // Primary
        },
        secondary: {
            main: '#2D5A27', // Secondary
            light: '#b9eeab',
        },
        tertiary: {
            main: '#884513', // Tertiary
        },
        alert: {
            main: red[500]
        },
        background: {
            default: '#fbf9f8', // Fondo claro
            paper: '#ffffff', // Fondo de elementos como tarjetas
            overPaper: '#e4e2e1'
        },
        text: {
            primary: '#333333', // Neutral dark
            secondary: '#504533', // Texto secundario
        },
        inputs: {
            active: '#333333',
            disabled: '#837560'
        },
    },
    breakpoints: {
        values: {
            laptop: 1024,
            tablet: 640,
            mobile: 0,
            desktop: 1280,
        },
    }
});

export default temaClaro;